import t, {parseSchema} from './Base';
export {parseSchema};
export default t;